import Header from "../../../../Components/Header/Header";
import Sidebar from "../../../../Components/Sidebar/Sidebar";
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import ViewURL from "../../../../Components/ViewURL/ViewURL";
import { useAuthState } from "../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import { GardenMasterDeleteAPI, GardenMasterExportTableDataAPI, GardenMasterTableDataAPI } from "../../../../Redux/MasterSlice/GardenMasterSlice";
import GardenPopup from "../GardenPopup/GardenPopup";
import DeletePopup from "../GardenPopup/DeletePopup";
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL";
import { SectorDataDDL } from "../../../../Components/CommonDDL/SectorDataDDL";
import { Pegination } from "../../../../Components/Pegination/Pegination";
import { Loading } from "../../../../Helper/Loading";
import MapView2 from "../../../../Components/MapView/MapView2";


import { useSearchParams } from "react-router-dom";
import { GardenMasterExportData } from "./GardenMasterExportData";
import { TableNote } from "../../../../Components/Note/Note";

export default function ChowkData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [GardenMasterPopupShow, setGardenMasterPopupShow] = useState('')
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [ShowMap, setShowMap] = React.useState(false)
    const [LocationData, setLocationData] = React.useState({})
    const [YearValue, setYearValue] = useState(0)
    const [isSearch, setIsSearch] = useState(false)

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setGardenMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setGardenMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setGardenMasterPopupShow(false)
    }

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [SectorName, setSectorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const handleLocation = (item) => {
        if (item.assetLatitude && item.assetLongitude) {
            setShowMap(true)
            setLocationData({
                latitude: item.assetLatitude,
                longitude: item.assetLongitude
            })
        }
    }

    const handleCloseMap = () => {
        setShowMap(false)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setSectorName({
            ...SectorName,
            ID: 0,
            Label: 'Select...',
        })

        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_AssetID: item.m_AssetID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(GardenMasterDeleteAPI({ data }))
    }


    useEffect(() => {
        const data = {
            M_AssetID: 0,
            UserID: UserID,
            token: token,
            From: From,
            To: To,
            M_AssetTypeID: '5',
            M_WardID: WardName.ID,
            M_GD_SectorID: SectorName.ID,
            handleGetExport: handleGetExport
        }
        dispatch(GardenMasterTableDataAPI({ data }))
    }, [IsPost, To, IsClear, isSearch])

    const handleGetExport = () => {
        const data = {
            M_AssetID: 0,
            UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
            M_AssetTypeID: '5',
            M_WardID: WardName.ID,
            M_GD_SectorID: SectorName.ID,
        }
        // if (WardName.ID !== 0) {
        dispatch(GardenMasterExportTableDataAPI({ data }))
        // }
    }
    // , [IsPost, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.GardenMasterTableData)
    const { GardenExporttableData, isExportLoading } = useSelector(state => state.GardenMasterExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    setYearValue={setYearValue}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} active='chowks' />
                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-2 pb-4 master_border">
                                <div>
                                    <h5 className="">Chowk's Master</h5>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                // GardenExporttableData && GardenExporttableData.table && GardenExporttableData.table.length > 0 &&
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <GardenMasterExportData
                                                    ExcelData={GardenExporttableData}
                                                    name='Chowks Master'
                                                    searchName={searchName}
                                                />
                                        }
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1  rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12  ">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <SectorDataDDL
                                                        SectorName={SectorName}
                                                        setSectorName={setSectorName}
                                                        WardName={WardName}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>chowks Name</b></label>
                                                        <Select
                                                            isClearable
                                                            // isRtl={isRtl}
                                                            // className="ddl_width2"
                                                            isSearchable
                                                            // isDisabled={IsDisabled}
                                                            maxMenuHeight={150}
                                                        // value={{ value: GardenName.ID, label: GardenName.Label }}
                                                        // onChange={(e) => {
                                                        //     e ?
                                                        //         setGardenName({ ...GardenName, ID: e.value, Label: e.label })
                                                        //         :
                                                        //         setGardenName({ ...GardenName, ID: 0, Label: "Select..." })

                                                        // }}
                                                        // options={GardenName.DDL}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-3 col-md-4 mt-lg-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            {/* <TableNote /> */}
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Ward Name	 </th>
                                                            <th>Sector Name	 </th>
                                                            <th>Area Name</th>
                                                            <th>chowks Name</th>
                                                            <th>Area (in sq meter)</th>
                                                            <th>Image</th>
                                                            <th>Track</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    <td>{item.sectorName ? item.sectorName : '-'}</td>
                                                                    <td>{item.areaName ? item.areaName : '-'}</td>
                                                                    <td>{item.assetName ? item.assetName : '-'}</td>
                                                                    <td>{item.areaInSquareMetre ? item.areaInSquareMetre : '-'}</td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.assetPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => handleShowImage(item.assetPhoto)}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.assetLatitude == null && item.assetLongitude == null) ?
                                                                                <span>-</span> :
                                                                                <>
                                                                                    <i style={{ cursor: 'pointer', fontSize: '1rem' }}
                                                                                        className="fa-solid fa-location-dot"
                                                                                        onClick={() => handleLocation(item)}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: "center", }}>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>


                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    ShowMap ?
                        <MapView2
                            LoactionData={LocationData}
                            ShowMap={ShowMap}
                            handleCloseMap={handleCloseMap}
                            currEmployeeName=''
                        />
                        : ''
                }
                {
                    showImagePopup ?
                        <ViewURL
                            Heading="Asset Photo"
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''
                }
                {
                    GardenMasterPopupShow ?
                        <GardenPopup
                            open={GardenMasterPopupShow}
                            GardenMasterFlag='GardenMaster'
                            popupHeading="Chowk's"
                            M_AssetTypeID='5'
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div >
        </>
    )
}